'use client'
import { RecentSearchListItem } from '@/src/hooks/srp/recentSearch'
import { useLocale, useTranslations } from 'next-intl'
import { useState } from 'react'
import { isCleartrip } from '@/src/utils/generalUtils/isCleartrip'
import { FlightSearchTabs as FlightSearchTabsComponent } from './flightSearchTabs'

interface FlightSearchTabsProps {
    isMobile: boolean
    serverRecentSearches: RecentSearchListItem[]
    hideMulticity?: boolean
    fromParam?: any[] | null
    toParam?: any[] | null
    showVisaTab?: boolean
    showFlightsHotelsTab?: boolean
}

export const FlightSearchTabs = ({
    isMobile,
    serverRecentSearches,
    hideMulticity,
    fromParam,
    toParam,
    showVisaTab = false,
    showFlightsHotelsTab = false
}: FlightSearchTabsProps) => {
    const [tabValue, setTabValue] = useState(0)
    const locale = useLocale()
    const t = useTranslations('header')

    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
        if (newValue === 1) {
            const hotelsHref = isCleartrip() ? '/hotels' : `/${locale}/hotels`
            window.location.href = hotelsHref
        } else if (newValue === 2) {
            const thirdHref = showVisaTab ? '/visa' : `/${locale}/flights-hotels`
            window.location.href = thirdHref
        } else {
            setTabValue(newValue)
        }
    }

    return (
        <FlightSearchTabsComponent
            t={t}
            tabValue={tabValue}
            onTabChange={handleTabChange}
            isMobile={isMobile}
            serverRecentSearches={serverRecentSearches}
            hideMulticity={hideMulticity}
            fromParam={fromParam}
            toParam={toParam}
            showVisaTab={showVisaTab}
            showFlightsHotelsTab={showFlightsHotelsTab}
        />
    )
}
